import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "w-220" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AgGridVue = _resolveComponent("AgGridVue")!

  return (_ctx.inScreenMode)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({ 'filled-table': _ctx.items && _ctx.items.length > 0 })
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([{ 'clickable-rows': _ctx.clickableRows }, "overflow-x-auto relative max-w-full grid overflow-hidden"])
        }, [
          _createVNode(_component_AgGridVue, {
            class: "ag-theme-material",
            "animate-rows": true,
            "row-selection": "single",
            "grid-options": _ctx.gridOptions,
            "column-defs": _ctx.headers,
            "row-data": _ctx.items,
            onSelectionChanged: _ctx.onSelectionChanged,
            onGridReady: _ctx.onGridReady,
            onGridSizeChanged: _ctx.onGridSizeChanged,
            onFirstDataRendered: _ctx.onFirstDataRendered
          }, null, 8, ["grid-options", "column-defs", "row-data", "onSelectionChanged", "onGridReady", "onGridSizeChanged", "onFirstDataRendered"])
        ], 2)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_AgGridVue, {
            class: "ag-theme-material",
            "animate-rows": true,
            "row-selection": "single",
            "grid-options": _ctx.gridOptions,
            "column-defs": _ctx.headers,
            "row-data": _ctx.items,
            onSelectionChanged: _ctx.onSelectionChanged,
            onGridReady: _ctx.onGridReady,
            onGridSizeChanged: _ctx.onGridSizeChanged,
            onFirstDataRendered: _ctx.onFirstDataRendered
          }, null, 8, ["grid-options", "column-defs", "row-data", "onSelectionChanged", "onGridReady", "onGridSizeChanged", "onFirstDataRendered"])
        ])
      ]))
}